import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';

import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { Box, Button, Checkbox, Divider, ProgressBar, Stack, Text } from 'shell/components';

const QuestionnaireStep = forwardRef(
    ({ surveys, STEPS, setStep, method, setMethod, onClickGenerate, onClickReset }, ref) => {
        const history = useHistory();
        const { studentAccountUsers } = useApp();
        const { device } = useViewport();

        const handleChange = (e) => {
            if (e.target.checked) {
                setMethod('all');
            } else {
                setMethod('survey');
            }
        };

        return (
            <Box ref={ref}>
                {studentAccountUsers.length ? (
                    <Stack
                        sx={{ m: '2rem auto 0', maxWidth: '30rem' }}
                        alignItems={'center'}
                        divider={<Divider flexItem />}
                        spacing={6}
                    >
                        <Stack spacing={4}>
                            {device === 'mobile' ? (
                                <>
                                    <Text align={'center'} variant={'h6'} weight={'semibold'}>
                                        Questionnaire Sent to Students!
                                    </Text>
                                    <Text align={'center'} variant={'p1'}>
                                        A questionnaire has been sent to your students to fill out. When your students
                                        have filled it out, come back and generate teams. You can remind students using
                                        the bell icon below.
                                    </Text>
                                    <Button
                                        sx={{ alignSelf: 'center', width: 'fit-content' }}
                                        variant={'secondary'}
                                        onClick={() => setStep(STEPS[0])}
                                    >
                                        Edit Criteria
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Stack alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'}>
                                        <Text variant={'h6'} weight={'semibold'}>
                                            Questionnaire Sent to Students!
                                        </Text>
                                        <Button
                                            sx={{ flexShrink: 0 }}
                                            variant={'secondary'}
                                            onClick={() => setStep(STEPS[0])}
                                        >
                                            Edit Criteria
                                        </Button>
                                    </Stack>
                                    <Text variant={'p1'}>
                                        A questionnaire has been sent to your students to fill out. When your students
                                        have filled it out, come back and generate teams. You can remind students using
                                        the bell icon below.
                                    </Text>
                                </>
                            )}
                        </Stack>
                        <Stack sx={{ width: '100%' }} alignItems={'center'} spacing={10}>
                            <Stack sx={{ width: '100%' }} spacing={2}>
                                <Text variant={'p1'}>Student Completion</Text>
                                <ProgressBar value={(surveys.length / studentAccountUsers.length) * 100} />
                                <Stack direction={'row'} justifyContent={'space-between'}>
                                    <Text variant={'p2'}>
                                        Completed: {surveys.length}/{studentAccountUsers.length} students
                                    </Text>
                                    <Text variant={'p2'}>
                                        Missing: {studentAccountUsers.length - surveys.length}/
                                        {studentAccountUsers.length} students
                                    </Text>
                                </Stack>
                            </Stack>
                            <Stack spacing={2}>
                                <Checkbox
                                    checked={method === 'all'}
                                    label={'Include students who did not submit the questionnaire in team generation'}
                                    noWrap={false}
                                    onChange={handleChange}
                                />
                            </Stack>
                            <Stack sx={{ width: 'fit-content' }} spacing={4}>
                                <Button onClick={onClickGenerate}>Generate Teams Now</Button>
                                <Button color={'neutral'} variant={'tertiary'} onClick={onClickReset}>
                                    Reset Group Formation
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                ) : (
                    <Stack
                        sx={{ m: '2rem auto 0', maxWidth: '30rem' }}
                        alignItems={'center'}
                        divider={<Divider flexItem />}
                        spacing={6}
                    >
                        <Stack spacing={4}>
                            <Stack alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'}>
                                <Text variant={'h6'} weight={'semibold'}>
                                    Questionnaire Created!
                                </Text>
                                <Button variant={'secondary'} onClick={() => setStep(STEPS[0])}>
                                    Edit Criteria
                                </Button>
                            </Stack>
                            <Text variant={'p1'}>
                                You don’t have any students in the course yet. When you invite students in the “members”
                                tab or by using the button below, students will automatically be sent this questionnaire
                                to complete. Come back when they have filled it out to generate teams.
                            </Text>
                        </Stack>
                        <Stack sx={{ mt: 4, width: 'fit-content' }} spacing={4}>
                            <Button onClick={() => history.push('/people/members')}>Invite Students Now</Button>
                            <Button color={'neutral'} variant={'tertiary'} onClick={onClickReset}>
                                Reset Group Formation
                            </Button>
                        </Stack>
                    </Stack>
                )}
            </Box>
        );
    }
);

export default QuestionnaireStep;
